import React, { useEffect, useState } from 'react';
import { fetchConfigs, initConfigs, putConfigs, createConfigs } from '../../api/api';
import EditConfig from './EditConfig';
import './AdminConfig.css';

const AdminConfig = () => {
    const [configs, setConfigs] = useState([]);
    const [selectedConfig, setSelectedConfig] = useState(null);
    const [addingNew, setAddingNew] = useState(false);
    const [newKey, setNewKey] = useState('');
    const [newValue, setNewValue] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        loadConfigs();
    }, []);

    const loadConfigs = async () => {
        try {
            const response = await fetchConfigs();
            if (response) {
                setConfigs(response);    
            }
        }
        catch (error) {
            if (error.response?.data?.message) {
                console.log(error);
                setError(error.response.data.message);
            } else {
                setError('Loading configs failed', error);
            }
        }
    };

    const handleAddConfig = async (e) => {
        e.preventDefault();
        if (!newKey.trim()) {
            setError('Key is required');
            return;
        }
        await handleSave(newKey.trim(), newValue);
        setNewKey('');
        setNewValue('');
    };

    const handleSave = async (key, value) => {
        try {
            if (addingNew) {
                // Create new config via POST
                await createConfigs({ key, value });
            } else {
                // Update config via PUT
                await putConfigs({ key, value });
            }

            setSelectedConfig(null);
            setAddingNew(false);
            loadConfigs();        
        } catch (error) {
            if (error.response?.data?.message) {
                console.log(error);
                setError(error.response.data.message);
            } else {
                setError('Updating configs failed', error);
            } 
        }
    };

    const handleInitConfigs = async (e) => {
        e.preventDefault();
        try {
            await initConfigs();
            loadConfigs();
        } catch (error) {
            if (error.response?.data?.message) {
                console.log(error);
                setError(error.response.data.message);
            } else {
                setError('Updating configs failed', error);
            }
        }
    }

    return (
        <div className="admin-component">
            <h2>Configuration Management</h2>
            {error && <p className='form-error'>{error}</p>}
            <div className='config-name'>
                {configs.map((config) => (
                    <p className='config-name-p' key={config.key}>
                        {config.key}
                        <button className='edit-btn right-aligned' onClick={() => setSelectedConfig(config)}>Edit</button>
                    </p>
                ))}
            </div>
            {selectedConfig && (
                <EditConfig config={selectedConfig} onSave={handleSave} />
            )}
            <button className='small-button' onClick={handleInitConfigs}>Init configs</button>

            <hr />
            {!addingNew ? (
                <button className='small-button' onClick={() => setAddingNew(true)}>+ Add New Config</button>
            ) : (
                <form onSubmit={handleAddConfig} className="add-config-form">
                    <h4>Add New Config</h4>
                    <input
                        type="text"
                        placeholder="Config Key"
                        value={newKey}
                        onChange={(e) => setNewKey(e.target.value)}
                    />
                    <input
                        type="text"
                        placeholder="Config Value"
                        value={newValue}
                        onChange={(e) => setNewValue(e.target.value)}
                    />
                    <button type="submit" className="small-button">Save</button>
                    <button type="button" className="small-button" onClick={() => {
                        setAddingNew(false);
                        setNewKey('');
                        setNewValue('');
                    }}>Cancel</button>
                </form>
            )}
        </div>
    );
};

export default AdminConfig;
